module.exports = __webpack_public_path__ + "static/assets/b6ee11f900db7fc0189f92d0e23e1f04.png";